import type { ServerColDef } from '@cmg/data-grid';

import type { FirmInvestorContactsGridItemFragment } from '../graphql/__generated__';
import { EditActionCellRenderer } from './EditActionCellRenderer';

export const editActionColDef: ServerColDef<FirmInvestorContactsGridItemFragment> = {
  colId: 'editAction',
  headerName: '',
  sortable: false,
  filter: false,
  width: 50,
  cellRenderer: EditActionCellRenderer,
};
